import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Mui from '@material-ui/core';
import * as MuiIcons from '@material-ui/icons';

const ModalObservacaoLiberacao = ({ open, onClose, callback }) => {
  const [observacao, setObservacao] = useState(null);

  const handleSubmit = () => {
    if (callback) {
      callback(observacao);
    }
  };

  return (
    <Mui.Dialog
      open={open}
      onKeyDown={key => {
        if (key.code === 'Escape') {
          onClose();
        }
      }}
      PaperComponent={Mui.Paper}
      maxWidth={'md'}
    >
      <Mui.DialogContent style={{ width: 540, padding: 32 }}>
        <Mui.Box textAlign="center" mb={4}>
          <Mui.Typography variant="h2" style={{ marginBottom: 16 }}>
            Informe o motivo da liberação
          </Mui.Typography>
          <Mui.TextField
            label="Observação"
            variant="outlined"
            minRows={3}
            fullWidth
            value={observacao}
            onChange={e => setObservacao(e.target.value)}
            error={!observacao || observacao?.length > 300}
          />
          <span>{observacao?.length ?? 0}/300</span>
        </Mui.Box>
      </Mui.DialogContent>
      <Mui.DialogActions>
        <Mui.Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          style={{ marginLeft: 8 }}
          disabled={!observacao || observacao?.length > 300}
        >
          <MuiIcons.CheckCircle />{' '}
          <Mui.Typography variant="inherit" component="span" style={{ marginLeft: 8 }}>
            Confirmar e Fechar
          </Mui.Typography>
        </Mui.Button>
        <Mui.Button size="large" style={{ marginLeft: 8 }} onClick={onClose}>
          <MuiIcons.Cancel />{' '}
          <Mui.Typography variant="inherit" component="span" style={{ marginLeft: 8 }}>
            Cancelar (ESC)
          </Mui.Typography>
        </Mui.Button>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
};

export default ModalObservacaoLiberacao;
